
define(
	'Tavanoteam.StoreLocatorExtended.StoreLocatorExtended'
	, [
		'StoreLocator.List.All.Store.View'
		, 'underscore'
	]
	, function (
		StoreLocatorListAllStoreView
		, _
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				_.extend(StoreLocatorListAllStoreView.prototype, {
					getContext: _.wrap(StoreLocatorListAllStoreView.prototype.getContext, function getContext(fn) {
						var context = fn.call(this);
						var imageUrl = this.model.get('storeImageUrl')

						context.imageUrl = imageUrl;

						return context;
					})
				});

			}
		};
	});
